import { createContext, useContext } from 'react';
import type { ErisUser } from 'src/api/eris/store/ErisUserStore';

export type AuthStatus =
  | 'loading'
  | 'unauthenticated'
  | 'authenticated'
  | 'token_expired'
  | 'callback_error';

export type AuthContextValue = {
  clearError: () => void;
  error: string | null;
  isAuthenticated: boolean;
  isConfigured: boolean;
  loadUser: () => Promise<ErisUser | null>;
  login: () => void;
  logout: () => Promise<void>;
  status: AuthStatus;
  token: string | null;
  user: ErisUser | null;
};

export const AppAuthContext = createContext<AuthContextValue | undefined>(undefined);

export function useAuth() {
  const context = useContext(AppAuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider.');
  }

  return context;
}
